module.exports = __webpack_public_path__ + "fonts/ComicNeueSansID.806bd32d.eot";